import React from 'react';
import Link from '../Link/Link';

import s from './ErrorComponent.scss';

const ErrorComponent = () => {
  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        <h2>OOPS, OUR BAD.</h2>
        <p className={s.text}>
          We&apos;re sorry. An error has occurred when attempting to process
          your request. Please go back and try your request again, or return at
          a later time.
        </p>
        <div>
          <Link
            size="large"
            url="/womens-clothing"
            appearance="button"
            className={s.button}
          >
            SHOP WOMEN
          </Link>
          <Link
            size="large"
            url="/mens-clothing"
            appearance="button"
            className={s.button}
          >
            SHOP MEN
          </Link>
          <Link
            size="large"
            url="/clothing-sale"
            appearance="button"
            className={s.button}
          >
            SHOP SALE
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
